export const translations = {
    fr: {
        nav: {
            about: "À Propos",
            technology: "Technologie",
            markets: "Marchés",
            sustainability: "Durabilité",
            contact: "Contact",
        },
        seo: {
            title: "Repas auto-chauffants longue conservation",
            desc: "T-Box révolutionne l'alimentation avec des repas de qualité longue conservation, activables sans réfrigération ni électricité. Idéal pour l'urgence, le voyage et l'outdoor.",
            keywords: "repas auto-chauffant, longue conservation, ration urgence, repas outdoor, sans électricité, t-box international"
        },
        hero: {
            title: "T-Box : Activer, patienter, déguster, votre repas chaud en 4 minutes!",
            desc: "T-Box révolutionne l'alimentation avec des repas de qualité longue conservation, activables sans réfrigération ni électricité. Une solution idéale pour une alimentation pratique, n'importe où, n'importe quand."
        },
        about: {
            title: "À Propos de T-Box",
            desc: "T-Box est une entreprise pionnière qui offre des repas pratiques et accessibles pour tous types de besoins, partout dans le monde. Nous nous engageons à fournir des repas de qualité, prêts à être consommés, avec une conservation prolongée sans dépendre d'équipements réfrigérants. Notre mission est de rendre les repas chauds disponibles pour tous, quels que soient les contextes et les environnements."
        },
        technology: {
            title: "Technologie Innovante",
            desc: "La technologie de réchauffement automatique brevetée de T-Box permet de chauffer les repas en seulement 2 à 5 minutes grâce à une réaction exothermique naturelle, sans danger et sans besoin d'électricité. Chaque repas est maintenu chaud pendant 30 minutes, offrant ainsi une flexibilité unique dans les environnements où les ressources sont limitées.",
            list: [
                "Conservation des repas jusqu'à 2 ans",
                "Réaction exothermique naturelle et sécurisée",
                "Matériaux sûrs et recyclables"
            ],
            steps: [
                "Appuyez sur le bouton sur le côté de la boîte pour commencer.",
                "Laissez chauffer pendant 2 minutes.",
                "Ouvrez la boîte et remuez avant de manger. Bon appétit."
            ]
        },
        markets: {
            title: "Nos Marchés",
            desc: "T-Box s'adresse à plusieurs secteurs nécessitant des repas prêts à consommer, pratiques et faciles à stocker. Nos solutions couvrent divers domaines comme le tourisme, la santé, les agences humanitaires, et bien d'autres.",
            list: [
                { title: "Tourisme et Hôtellerie :", desc: "Des repas chauds et rapides pour les voyageurs et les hôtels" },
                { title: "Aéroports et Compagnies Aériennes :", desc: "Une solution idéale pour les repas à bord" },
                { title: "Militaire et Logistique :", desc: "Des repas durables dans des conditions extrêmes" },
                { title: "Agences Humanitaires :", desc: "Des repas chauds pour les situations d'urgence" },
                { title: "Hôpitaux et Maisons de Retraite :", desc: "Des repas pratiques pour les patients et les résidents" },
                { title: "Supermarchés et distributeurs automatiques :", desc: "Des repas accessibles et chauds dans les lieux publics" },
                { title: "Industrie du Transport :", desc: "Des repas pour les trains, bus et autres transports en commun" },
                { title: "Camping et Loisirs en Plein Air :", desc: "Des repas simples et rapides pour les campeurs" },
                { title: "Événements Sportifs :", desc: "Une solution pratique pour les spectateurs et participants" },
                { title: "Crises Humanitaires :", desc: "Nourrir rapidement les victimes de catastrophes naturelles" },
                { title: "Éducation :", desc: "Des repas équilibrés pour les cantines scolaires et universitaires" },
                { title: "Entreprises :", desc: "Des repas faciles à stocker pour les employés en entreprise" }
            ]
        },
        sustainability: {
            title: "Engagement Écologique",
            desc: "T-Box est déterminé à réduire son impact environnemental en utilisant des matériaux recyclables et en mettant en place des processus de production respectueux de l'environnement. Nous croyons qu'il est possible d'offrir des repas de qualité tout en préservant les ressources de notre planète."
        },
        founders: {
            name: "Fondateur : Michel Cohen",
            desc: "Michel Cohen possède une vaste expérience dans l'acquisition, la mise en œuvre, le développement, la gestion, la coordination et la gestion de chaînes de magasins dans le secteur du textile féminin (200 magasins et plus).",
            list: [
                "20 ans d'expérience dans la fabrication de textiles, la mise en place de chaînes de production en Chine, au Maroc, en France, en Thaïlande, en Inde et en Malaisie. Création, sourcing, marques propres et co-branding avec des marques telles que ZARA, H & M, PROMOD, CAMAIEU, CELIO, MARKS & SPENCER et CARREFOUR.",
                "10 ans d'expérience dans les énergies renouvelables (photovoltaïque, éoliennes, turbines hydrauliques), avec des installations dans le monde entier de centrales électriques en mégawatts (SKY POWER).",
                "Constructeur, entrepreneur, promotions immobilières et ventes dans des bâtiments privés et de bureaux à travers Israël.",
                "Expérience en logistique, stockage, transport de produits frais et surgelés, et répartition. A travaillé avec les hypermarchés Carrefour et sur les marchés alimentaires.",
                "Actif depuis 7 ans dans l'industrie alimentaire israélienne. Fondateur et développeur de la technologie TBOX, préparant une introduction en bourse (IPO)."
            ]
        },
        contact: {
            title: "Contact",
            desc: "Pour plus d'informations sur T-Box, contactez-nous.",
            form: {
                firstname: "Prénom:",
                lastname: "Nom:",
                email: "Email:",
                telephone: "Téléphone:",
                address: "Adresse:",
                subject: "Sujet:",
                message: "Message:",
                submit: "Envoyer"
            },
            validation: {
                firstname: "Le prénom est requis",
                lastname: "Le nom est requis",
                email: "Email invalide",
                telephone: "Le téléphone est requis",
                subject: "Le sujet est requis",
                message: "Le message est requis"
            },
            toast: {
                successTitle: "✓ Envoyé",
                errorTitle: "✗ Erreur",
                successMessage: "Votre message a été envoyé avec succès !",
                errorMessage: "Erreur lors de l'envoi du message."
            },
            address: {
                title: "Siège Social",
                lines: ["LUSFLEY COMPANY S.A.", "Montevideo, Uruguay", "Avda. Dr. Luis Albe 1052, 1402"]
            },
            follow: "Suivez-nous sur nos réseaux sociaux :"
        }
    },
    en: {
        nav: {
            about: "About",
            technology: "Technology",
            markets: "Markets",
            sustainability: "Sustainability",
            contact: "Contact",
        },
        seo: {
            title: "Self-heating long shelf-life meals",
            desc: "T-Box revolutionizes food with high-quality long shelf-life meals, activatable without refrigeration or electricity. Ideal for emergency, travel, and outdoor.",
            keywords: "self-heating meal, long shelf life, emergency ration, outdoor food, no electricity, t-box international"
        },
        hero: {
            title: "T-Box: Activate, wait, enjoy, your hot meal in 4 minutes!",
            desc: "T-Box revolutionizes food with long-lasting quality meals, activated without refrigeration or electricity. An ideal solution for practical meals, anywhere, anytime."
        },
        about: {
            title: "About T-Box",
            desc: "T-Box is a pioneering company offering practical and accessible meals for all types of needs, anywhere in the world. We are committed to providing quality meals, ready to eat, with extended preservation without relying on refrigeration equipment. Our mission is to make hot meals available to everyone, in any context and environment."
        },
        technology: {
            title: "Innovative Technology",
            desc: "T-Box's patented auto-warming technology allows meals to be heated in just 2 to 5 minutes through a natural exothermic reaction, safe and without electricity. Each meal stays hot for 30 minutes, offering unique flexibility in resource-limited environments.",
            list: [
                "Meal preservation for up to 2 years",
                "Safe and natural exothermic reaction",
                "Safe and recyclable materials"
            ],
            steps: [
                "Press down the button on the side of the box to start.",
                "Allow food to heat for 2 minutes.",
                "Open the box and stir before eating. Enjoy your meal."
            ]
        },
        markets: {
            title: "Our Markets",
            desc: "T-Box serves several sectors requiring ready-to-eat, practical, and easy-to-store meals. Our solutions cover various fields such as tourism, health, humanitarian agencies, and more.",
            list: [
                { title: "Tourism and Hospitality:", desc: "Hot and quick meals for travelers and hotels" },
                { title: "Airports and Airlines:", desc: "An ideal solution for in-flight meals" },
                { title: "Military and Logistics:", desc: "Durable meals in extreme conditions" },
                { title: "Humanitarian Agencies:", desc: "Hot meals for emergency situations" },
                { title: "Hospitals and Retirement Homes:", desc: "Practical meals for patients and residents" },
                { title: "Supermarkets and Vending Machines:", desc: "Accessible and hot meals in public places" },
                { title: "Transport Industry:", desc: "Meals for trains, buses, and other public transportation" },
                { title: "Camping and Outdoor Recreation:", desc: "Simple and quick meals for campers" },
                { title: "Sporting Events:", desc: "A practical solution for spectators and participants" },
                { title: "Humanitarian Crises:", desc: "Quickly feeding victims of natural disasters" },
                { title: "Education:", desc: "Balanced meals for school and university cafeterias" },
                { title: "Businesses:", desc: "Easy-to-store meals for employees in the workplace" }
            ]
        },
        sustainability: {
            title: "Ecological Commitment",
            desc: "T-Box is committed to reducing its environmental impact by using recyclable materials and implementing environmentally friendly production processes. We believe it is possible to offer quality meals while preserving our planet's resources."
        },
        founders: {
            name: "Founder: Michel Cohen",
            desc: "Michel Cohen has extensive experience in acquisition, implementation, development, management, coordination, and management of chain stores in women's textiles (200 stores +).",
            list: [
                "20 years experience in the manufacture of textiles, establishment of production chains in China, Morocco, France, Thailand, India, and Malaysia. Creation, sourcing, private labels, and co-branding with brands like ZARA, H & M, PROMOD, CAMAIEU, CELIO, MARKS & SPENCER, and CARREFOUR.",
                "10 years of experience in renewable energy (Photovoltaics, Wind Turbines, Hydraulic Turbines), with installations around the world of power plants in Megawatts (SKY POWER).",
                "Builder, entrepreneur, real estate promotions, and sales in private and office buildings across Israel.",
                "Experienced in logistics, storage, transport of fresh and frozen products, and dispatching. Worked with Carrefour superstores and in food markets.",
                "Has been active for 7 years in the Israeli food industry. Founder and developer of TBOX technology, preparing for IPO initial public offering."
            ]
        },
        contact: {
            title: "Contact",
            desc: "For more information about T-Box, contact us.",
            form: {
                firstname: "First Name:",
                lastname: "Last Name:",
                email: "Email:",
                telephone: "Phone:",
                address: "Address:",
                subject: "Subject:",
                message: "Message:",
                submit: "Submit"
            },
            validation: {
                firstname: "First name is required",
                lastname: "Last name is required",
                email: "Invalid email",
                telephone: "Phone is required",
                subject: "Subject is required",
                message: "Message is required"
            },
            toast: {
                successTitle: "✓ Sent",
                errorTitle: "✗ Error",
                successMessage: "Your message has been sent successfully!",
                errorMessage: "Error sending message."
            },
            address: {
                title: "Head Office",
                lines: ["LUSFLEY COMPANY S.A.", "Montevideo, Uruguay", "Avda. Dr. Luis Albe 1052, 1402"]
            },
            follow: "Follow us on our social networks:"
        }
    },
    es: {
        nav: {
            about: "Sobre",
            technology: "Tecnología",
            markets: "Mercados",
            sustainability: "Sostenibilidad",
            contact: "Contacto",
        },
        seo: {
            title: "Comidas autocalentables de larga duración",
            desc: "T-Box revoluciona la alimentación con comidas de calidad de larga conservación, activables sin refrigeración ni electricidad. Ideal para emergencia, viaje y aire libre.",
            keywords: "comida autocalentable, larga duración, ración emergencia, comida outdoor, sin electricidad, t-box international"
        },
        hero: {
            title: "T-Box: Activa, espera, disfruta, tu comida caliente en 4 minutos!",
            desc: "T-Box revoluciona la alimentación con comidas de calidad de larga duración, activadas sin refrigeración ni electricidad. ¡Una solución ideal para comidas prácticas, en cualquier lugar y en cualquier momento!"
        },
        about: {
            title: "Sobre T-Box",
            desc: "T-Box es una empresa pionera que ofrece comidas cómodas y accesibles para todo tipo de necesidades, en cualquier parte del mundo. Estamos comprometidos a brindar comidas de calidad, listas para comer, con almacenamiento prolongado sin depender de equipos de refrigeración. Nuestra misión es hacer que las comidas calientes estén disponibles para todos, independientemente de los contextos y entornos."
        },
        technology: {
            title: "Tecnología Innovadora",
            desc: "La tecnología de calentamiento automático patentada de T-Box calienta las comidas en solo 2 a 5 minutos mediante una reacción exotérmica natural y segura sin necesidad de electricidad. Cada comida se mantiene caliente durante 30 minutos, lo que proporciona una flexibilidad única en entornos con recursos limitados.",
            list: [
                "Conservación de las comidas hasta por 2 años",
                "Reacción exotérmica natural y segura",
                "Materiales seguros y reciclables"
            ],
            steps: [
                "Presiona el botón en el lado de la caja para comenzar.",
                "Deja que la comida se caliente durante 2 minutos.",
                "Abre la caja y remueve antes de comer. Buen provecho."
            ]
        },
        markets: {
            title: "Nuestros Mercados",
            desc: "T-Box se dirige a varios sectores que requieren platos preparados que sean prácticos y fáciles de almacenar. Nuestras soluciones cubren diversas áreas como turismo, atención médica, agencias humanitarias y muchas otras.",
            list: [
                { title: "Turismo y Hotelería:", desc: "Comidas calientes y rápidas para viajeros y hoteles" },
                { title: "Aeropuertos y Compañías Aéreas:", desc: "Una solución ideal para las comidas a bordo" },
                { title: "Militar y Logística:", desc: "Comidas duraderas en condiciones extremas" },
                { title: "Agencias Humanitarias:", desc: "Comidas calientes para situaciones de emergencia" },
                { title: "Hospitales y Hogares de Ancianos:", desc: "Comidas prácticas para pacientes y residentes" },
                { title: "Supermercados y máquinas expendedoras:", desc: "Comidas accesibles y calientes en lugares públicos" },
                { title: "Industria del Transporte:", desc: "Comidas para trenes, autobuses y otros medios de transporte público" },
                { title: "Campamentos y Actividades al Aire Libre:", desc: "Comidas simples y rápidas para campistas" },
                { title: "Eventos Deportivos:", desc: "Una solución práctica para espectadores y participantes" },
                { title: "Crisis Humanitarias:", desc: "Alimentar rápidamente a las víctimas de desastres naturales" },
                { title: "Educación:", desc: "Comidas equilibradas para comedores escolares y universitarios" },
                { title: "Empresas:", desc: "Comidas fáciles de almacenar para los empleados en las empresas" }
            ]
        },
        sustainability: {
            title: "Compromiso Ecológico",
            desc: "T-Box está comprometido a reducir su impacto ambiental utilizando materiales reciclables y estableciendo procesos de producción respetuosos con el medio ambiente. Creemos que es posible ofrecer comidas de calidad mientras preservamos los recursos de nuestro planeta."
        },
        founders: {
            name: "Fundador: Michel Cohen",
            desc: "Michel Cohen tiene una vasta experiencia en la adquisición, implementación, desarrollo, gestión, coordinación y dirección de cadenas de tiendas en el sector de textiles femeninos (más de 200 tiendas).",
            list: [
                "20 años de experiencia en la fabricación de textiles, la creación de cadenas de producción en China, Marruecos, Francia, Tailandia, India y Malasia. Creación, abastecimiento, marcas propias y co-branding con marcas como ZARA, H & M, PROMOD, CAMAIEU, CELIO, MARKS & SPENCER y CARREFOUR.",
                "10 años de experiencia en energías renovables (fotovoltaica, eólica, turbinas hidráulicas), con instalaciones en todo el mundo de centrales eléctricas en megavatios (SKY POWER).",
                "Constructor, emprendedor, promotor inmobiliario y ventas en edificios privados y oficinas en todo Israel.",
                "Experiencia en logística, almacenamiento, transporte de productos frescos y congelados, y distribución. Ha trabajado con los hipermercados Carrefour y en los mercados de alimentos.",
                "Activo durante 7 años en la industria alimentaria israelí. Fundador y desarrollador de la tecnología TBOX, preparando una oferta pública inicial (IPO)."
            ]
        },
        contact: {
            title: "Contacto",
            desc: "Para más información sobre T-Box, contáctanos.",
            form: {
                firstname: "Nombre:",
                lastname: "Apellido:",
                email: "Correo Electrónico:",
                telephone: "Teléfono:",
                address: "Dirección:",
                subject: "Asunto:",
                message: "Mensaje:",
                submit: "Enviar"
            },
            validation: {
                firstname: "El nombre es obligatorio",
                lastname: "El apellido es obligatorio",
                email: "Correo electrónico inválido",
                telephone: "El teléfono es obligatorio",
                subject: "El asunto es obligatorio",
                message: "El mensaje es obligatorio"
            },
            toast: {
                successTitle: "✓ Enviado",
                errorTitle: "✗ Error",
                successMessage: "¡Tu mensaje ha sido enviado con éxito!",
                errorMessage: "Error al enviar el mensaje."
            },
            address: {
                title: "Oficina Central",
                lines: ["LUSFLEY COMPANY S.A.", "Montevideo, Uruguay", "Avda. Dr. Luis Albe 1052, 1402"]
            },
            follow: "Síguenos en nuestras redes sociales:"
        }
    },
    ar: {
        nav: {
            about: "حول",
            technology: "التكنولوجيا",
            markets: "الأسواق",
            sustainability: "الاستدامة",
            contact: "الاتصال",
        },
        seo: {
            title: "وجبات ذاتية التسخين طويلة الأمد",
            desc: "T-Box تحدث ثورة في الغذاء بوجبات عالية الجودة طويلة الأمد، قابلة للتفعيل بدون تبريد أو كهرباء. مثالية للطوارئ والسفر والأنشطة الخارجية.",
            keywords: "وجبة ذاتية التسخين, طويلة الأمد, حصة طوارئ, طعام خارجي, بدون كهرباء, تيبوكس انترناشيونال"
        },
        hero: {
            title: "T-Box: شغّل، انتظر، استمتع، وجبتك الساخنة في 4 دقائق!",
            desc: "T-Box تُحدث ثورة في الطعام مع وجبات ذات جودة تدوم طويلاً، تُفعل بدون تبريد أو كهرباء. الحل المثالي لوجبات عملية، في أي مكان وفي أي وقت!"
        },
        about: {
            title: "عن T-Box",
            desc: "T-Box هي شركة رائدة تقدم وجبات عملية وسهلة الوصول لتلبية جميع الاحتياجات، في أي مكان في العالم. نحن ملتزمون بتقديم وجبات عالية الجودة، جاهزة للأكل، مع فترة حفظ طويلة دون الحاجة إلى معدات تبريد. مهمتنا هي جعل الوجبات الساخنة متاحة للجميع، بغض النظر عن السياقات والبيئات."
        },
        technology: {
            title: "تقنية مبتكرة",
            desc: "تتيح تقنية التسخين التلقائي الحاصلة على براءة اختراع من T-Box تسخين الوجبات في 2 إلى 5 دقائق فقط من خلال تفاعل طارد للحرارة طبيعي وآمن بدون الحاجة إلى الكهرباء. تظل كل وجبة ساخنة لمدة 30 دقيقة، مما يوفر مرونة فريدة في البيئات ذات الموارد المحدودة.",
            list: [
                "الحفاظ على الوجبات لمدة تصل إلى سنتين",
                "تفاعل طارد للحرارة طبيعي وآمن",
                "مواد آمنة وقابلة لإعادة التدوير"
            ],
            steps: [
                "اضغط على الزر في جانب العلبة لبدء التشغيل.",
                "اترك الطعام يسخن لمدة دقيقتين.",
                "افتح العلبة وحرك الطعام قبل الأكل. استمتع بوجبتك."
            ]
        },
        markets: {
            title: "أسواقنا",
            desc: "تتوجه T-Box إلى عدة قطاعات تتطلب وجبات جاهزة للأكل، عملية وسهلة التخزين. تغطي حلولنا مجالات متنوعة مثل السياحة، الرعاية الصحية، الوكالات الإنسانية، وغيرها الكثير.",
            list: [
                { title: "السياحة والفنادق:", desc: "وجبات ساخنة وسريعة للمسافرين والفنادق" },
                { title: "المطارات وشركات الطيران:", desc: "حل مثالي للوجبات على متن الطائرة" },
                { title: "العسكرية واللوجستية:", desc: "وجبات تدوم في الظروف القاسية" },
                { title: "الوكالات الإنسانية:", desc: "وجبات ساخنة لحالات الطوارئ" },
                { title: "المستشفيات ودور الرعاية:", desc: "وجبات عملية للمرضى والمقيمين" },
                { title: "محلات السوبر ماركت وآلات البيع:", desc: "وجبات سهلة الوصول وساخنة في الأماكن العامة" },
                { title: "صناعة النقل:", desc: "وجبات للقطارات والحافلات ووسائل النقل العامة الأخرى" },
                { title: "التخييم والترفيه في الهواء الطلق:", desc: "وجبات بسيطة وسريعة للمخيمين" },
                { title: "الأحداث الرياضية:", desc: "حل عملي للمشاهدين والمشاركين" },
                { title: "الأزمات الإنسانية:", desc: "تغذية سريعة لضحايا الكوارث الطبيعية" },
                { title: "التعليم:", desc: "وجبات متوازنة للمقاصف المدرسية والجامعية" },
                { title: "الشركات:", desc: "وجبات سهلة التخزين للموظفين في مكان العمل" }
            ]
        },
        sustainability: {
            title: "الالتزام البيئي",
            desc: "تلتزم T-Box بتقليل تأثيرها البيئي من خلال استخدام مواد قابلة لإعادة التدوير وتطبيق عمليات إنتاج تحترم البيئة. نحن نؤمن بأنه من الممكن تقديم وجبات ذات جودة عالية مع الحفاظ على موارد كوكبنا."
        },
        founders: {
            name: "المؤسس: ميشيل كوهين",
            desc: "يمتلك ميشيل خبرة واسعة في الاستحواذ، التنفيذ، التطوير، الإدارة، التنسيق وإدارة سلاسل المتاجر في قطاع الملابس النسائية (أكثر من 200 متجر).",
            list: [
                "20 عامًا من الخبرة في تصنيع المنسوجات، وإنشاء سلاسل الإنتاج في الصين، المغرب، فرنسا، تايلاند، الهند وماليزيا. إنشاء وتوريد العلامات التجارية الخاصة والعلامات التجارية المشتركة مع علامات تجارية مثل ZARA، H&M، PROMOD، CAMAIEU، CELIO، MARKS & SPENCER وCARREFOUR.",
                "10 سنوات من الخبرة في الطاقات المتجددة (الطاقة الشمسية، توربينات الرياح، التوربينات الهيدروليكية)، مع تركيب محطات كهرباء في جميع أنحاء العالم (SKY POWER).",
                "مقاول بناء، ومطور عقاري، وتطوير وبيع المباني الخاصة ومكاتب الأعمال في جميع أنحاء إسرائيل.",
                "خبرة في اللوجستيات، التخزين، نقل المنتجات الطازجة والمجمدة، والتوزيع. عمل مع الهايبرماركت Carrefour وفي الأسواق الغذائية.",
                "ناشط منذ 7 سنوات في صناعة الأغذية الإسرائيلية. مؤسس ومطور تكنولوجيا TBOX، ويستعد لطرح أولي في السوق (IPO)."
            ]
        },
        contact: {
            title: "اتصل بنا",
            desc: "لمزيد من المعلومات حول T-Box، اتصل بنا.",
            form: {
                firstname: "الاسم الأول:",
                lastname: "اللقب:",
                email: "البريد الإلكتروني:",
                telephone: "الهاتف:",
                address: "العنوان:",
                subject: "الموضوع:",
                message: "الرسالة:",
                submit: "إرسال"
            },
            validation: {
                firstname: "الاسم الأول مطلوب",
                lastname: "اللقب مطلوب",
                email: "بريد إلكتروني غير صالح",
                telephone: "الهاتف مطلوب",
                subject: "الموضوع مطلوب",
                message: "الرسالة مطلوبة"
            },
            toast: {
                successTitle: "✓ تم الإرسال",
                errorTitle: "✗ خطأ",
                successMessage: "تم إرسال رسالتك بنجاح!",
                errorMessage: "حدث خطأ أثناء إرسال الرسالة."
            },
            address: {
                title: "المقر الرئيسي",
                lines: ["LUSFLEY COMPANY S.A.", "Montevideo, Uruguay", "Avda. Dr. Luis Albe 1052, 1402"]
            },
            follow: "تابعونا على وسائل التواصل الاجتماعي:"
        }
    }
};
